export const team_mode = {
  create_channel: "Create Channel",
  share_document: "Share Document",
  subscribe_channel: "Subscribe to a channel",
  manage_channels: "Manage Channels",
  subscribers: "Subscribers",
  settings: "Settings",
  shared_content: "Shared @.lower:documents",
  created_at: "Created at",
  channel_data: "Channel Data",
  subscription: "Subscription",
  broadcast_channels: "Broadcast Channels",
  subscribed_channels: "Subscribed Channels",
  owned_channels: "Owned Channels",
  channel: "Channel",
  joined_at: "Joined at",
  date_of_joining: "Date of Joining",
};
